<<template>
  <div :class="!_isMobile ? 'wrapperPcY' : ''">
    <img src="../assets/image/yywy-1.jpg" />
    <img src="../assets/image/yywy-2.jpg" />
    <img src="../assets/image/yywy-3.jpg" />
    <img src="../assets/image/yywy-4.jpg" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      _isMobile: false,
    }
  },
  created() {
    this._isMobile = this.$util._isMobile()
  },
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  display: grid;
}
.wrapperPcY {
  width: 750px;
  margin: 0 auto;
  display: grid;
}
</style>
  


// WEBPACK FOOTER //
// src/views/yywy.vue